import Vue from 'vue'
import { Store } from 'vuex'

import commerceModule from './store'
import { getTariffNameByOptionKey } from './store/modules/TariffsServise/helpers'

export default function (vue: typeof Vue, options: { store: Store<any> }): void {
  if (!options || !options.store) {
    throw new Error('Please initialise plugin with a Vuex store.')
  }

  if (!options.store.hasModule('commerce')) {
    // REGISTER TARIFFS MODULE
    options.store.registerModule('commerce', commerceModule)
  } else {
    throw new Error('commerce module error: module already exists')
  }

  if ((vue as any).prototype.$getOptionTariff === undefined) {
    // TODO: http://localhost:8080/chat/-253211873/filters/web_links has always error
    // TODO: Error only without license, and network error without any request
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    (vue as any).prototype.$getOptionTariff = (option: string): string | undefined => {
      if (options.store.state.commerce.TariffService.tariffsMap) {
        return getTariffNameByOptionKey(options.store.state.commerce.TariffService.tariffsMap, option)
      }
      throw new Error('"tariffsMap" is null. \n Please fill it.')
    }
  }
}
